<template>
  <div
    class="badge"
    :class="'--is-' + color"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Badge',
  props: {
    color: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * Badge
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Badge, used as red bubble for notifications or small
 * labels on top or right next to other UI components.
 * @since 2022-03-04
**/

$component: 'badge';

.#{$component} {
  display: inline-block;
  @include margin-right(map-get($spacers, 2));
  padding: 0.2rem 0.4rem;
  border-radius: $border-radius;
  background-color: $ink-lightest;
  color: $ink-light;
  font-size: 0.7rem;
  line-height: 1;

  &.--is-yellow {
    background-color: $yellow;
    color: $ink;
  }

  &.--is-red {
    background-color: $red;
    color: $white;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
